import debug from 'bows';

class Map {
	constructor( node ) {
		this.debug = debug('layout:map');
		this.node = node;
		this.defaultState = this.node.getAttribute('data-default-state');
		this.map = this.node.querySelector('.flex-layout--map__map > svg');
		this.states = {};
		this.contents = {};
		this.active = null;
		this.activeClass = 'active';

		Array.from(this.node.querySelectorAll('.flex-layout--map__map g[data-state]')).forEach((node) => {
			let state = node.getAttribute('data-state');
			this.states[state] = node;
			node.addEventListener('click', () => {
				this.activate( state );
			});
		});

		Array.from(this.node.querySelectorAll('.flex-layout--map__state')).forEach((node) => {
			let state = node.getAttribute('data-state');
			this.contents[state] = node;
		});

		this.select = this.node.querySelector('.flex-layout--map__select');
		if ( this.select ) {
			this.select.addEventListener( 'change', () => {
				this.activate(this.select.value);
			});
		}

		if ( this.defaultState ) {
			this.activate( this.defaultState );
		}

		this.debug(this);
	}

	activate( state ) {
		if ( this.states[state] ) {
			if (this.active) {
				this.states[this.active].classList.remove(this.activeClass);
				this.contents[this.active].classList.remove(this.activeClass);
			}

			this.active = state;
			this.states[this.active].classList.add(this.activeClass);
			this.contents[this.active].classList.add(this.activeClass);
			this.map.appendChild(this.states[this.active]); // move state to bottom of the list so border effect works
			this.select.value = state;
		}
	}
}

export default Map;
